// variant: 'lite' asks the backend to strip the same detail-page-only
// fields SSR_DEFERRED_PRODUCT_FIELDS strips client-side (applyFieldMapper.js)
// - keeps them in lockstep. Anything other than 'lite' is left off the URI
// entirely (backend already defaults to full when the param is omitted),
// so existing full-catalog requests/cache keys are unchanged.
export default function fetchWineCatalog(store, variant) {
  // Attempt to load the Wine Catalog from the VueJS Rest Endpoint (/vuejs/vincreative/product-catalog)
  let uri = store.state.registry.getServiceEndpoint('datastore') + '/vuejs/vincreative/product-catalog'
  if (variant === 'lite') uri += '?variant=lite'
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    redirect: 'follow',
    credentials: 'omit'
  }

  return fetch(uri, options)
    .then(resp => {
      if (resp.ok && resp.status) {
        return resp.json()
      }
      throw new Error('No REST Response or Invalid REST Response')
    })
}
